import React from 'react';
import PoolBalanceChart from '../components/PoolBalanceChart';
import TraderListTable from '../components/trader/TraderListTable';
import DepositorListTable from '../components/deposit/DepositorListTable';

const Dashboard: React.FC = () => {
  return (
    <div className="container mx-auto px-[16px] py-4 md:py-8 transition-colors duration-300 max-w-[1312px]">
      <div className="grid gap-4 md:gap-6 grid-cols-1 lg:grid-cols-2">
        <div className="col-span-1 lg:col-span-2 w-full">
          <PoolBalanceChart />
        </div>
        <div className="col-span-1">
          <TraderListTable mode="top" limit={20} />
        </div>
        <div className="col-span-1">
          <DepositorListTable mode="top" limit={20} />
        </div>
      </div>
    </div>
  );
};

export default Dashboard; 